import React from 'react';

const ProjectSuccess = () => {
  return <div className='bg-green w-full h-full'>ProjectSuccess</div>;
};

export default ProjectSuccess;
